import { render, staticRenderFns } from "./casesPic.vue?vue&type=template&id=22f1d760&scoped=true"
import script from "./casesPic.vue?vue&type=script&lang=js"
export * from "./casesPic.vue?vue&type=script&lang=js"
import style0 from "./casesPic.vue?vue&type=style&index=0&id=22f1d760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f1d760",
  null
  
)

export default component.exports